module.exports = __webpack_public_path__ + "img/dep_dairy@3x.df5dfa70.png";